import DatasetIcon from "@mui/icons-material/Dataset";
import EventNoteIcon from "@mui/icons-material/EventNote";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";

import {
  SchemaDefinitionConfig,
  TableTypeEnum,
} from "shared/api/schemaDefinitions/types";

import { MuiIconComponent } from "features/layout/SidebarNav/types";
import TenantIcon from "features/layout/TenantIcon";

const TABLE_TYPE_ICON_MAP: Record<TableTypeEnum, MuiIconComponent> = {
  [TableTypeEnum.EVENT]: EventNoteIcon,
  [TableTypeEnum.ASSET]: DatasetIcon,
  [TableTypeEnum.CATALOG]: LibraryBooksOutlinedIcon,
};

interface Props {
  tableType: TableTypeEnum;
  config?: SchemaDefinitionConfig;
  size: number;
}

const SchemaIcon = ({ tableType, config, size }: Props) => {
  if (config?.iconSvg) {
    return (
      <div
        style={{ width: size, height: size }}
        className="flex items-center justify-center overflow-hidden"
      >
        <TenantIcon svg={config.iconSvg} />
      </div>
    );
  }

  const FallbackIcon = TABLE_TYPE_ICON_MAP[tableType] ?? ListOutlinedIcon;

  return <FallbackIcon style={{ fontSize: `${size}px` }} />;
};

export default SchemaIcon;
